/** Nombres de mapas mencionados en la información de invasiones aprobada. */
export const mapNames: Record<string, string> = {
  lorencia: 'Lorencia',
  noria: 'Noria',
  devias: 'Devias',
  atlans: 'Atlans',
  'lost-tower': 'Lost Tower',
  aida: 'Aida',
  tarkan: 'Tarkan',
}

/** En qué mapas puede aparecer cada invasión (según su ubicación publicada). */
export const invasionMaps: Record<string, string[]> = {
  'death-king': ['lorencia', 'noria'],
  'red-dragon': ['lorencia', 'devias', 'noria'],
  'white-wizard': ['lorencia', 'devias', 'noria'],
  'new-year': ['atlans', 'lost-tower', 'aida'],
  rabbits: ['tarkan', 'lost-tower', 'lorencia'],
  summer: ['devias', 'noria', 'lorencia'],
}

export const invasionMapNames = (invasionId: string) => (invasionMaps[invasionId] ?? []).map((id) => mapNames[id])
